import React, { ReactNode, useMemo } from 'react';
import Table, { ITableTabs } from '@components/Table';
import { formatCurrency } from '@utils/formatters';
import { useTranslation } from 'react-i18next';

export interface IItemData {
  dsItem: string;
  nuQtdItem: number;
  nuValorUnitario: number;
  blItemEdit: 'S' | 'N';
  status?: string;
  idItemFatura?: number;
  nuValorTotal?: number;
}

interface ITableColumns {
  title: string;
  dataIndex: string;
  align?: 'center';
  render?: (value: any, record?: any) => any;
}

interface IInvoiceItems {
  data: IItemData[];
  tabs?: ITableTabs;
  extraColumns?: ITableColumns[];
  extraActions?: ReactNode;
}

const InvoiceItems: React.FC<IInvoiceItems> = ({
  data,
  tabs,
  extraColumns,
  extraActions,
}) => {
  const { t } = useTranslation('invoices');

  const columns: ITableColumns[] = useMemo(() => {
    const defaultColumns: ITableColumns[] = [
      {
        title: t('invoiceItem.id'),
        align: 'center' as const,
        dataIndex: 'idItemFatura',
      },
      { title: t('invoiceItem.description'), dataIndex: 'dsItem' },
      {
        title: t('invoiceItem.quantity'),
        align: 'center' as const,
        dataIndex: 'nuQtdItem',
      },
      {
        title: t('invoiceItem.unitValue'),
        align: 'center' as const,
        dataIndex: 'nuValorUnitario',
        render: (value: any) => formatCurrency(Number(value)),
      },
      {
        title: t('invoiceItem.totalValue'),
        align: 'center' as const,
        dataIndex: 'nuValorTotal',
        render: (value: any) => formatCurrency(Number(value)),
      },
    ];

    if (extraColumns) {
      defaultColumns.push(...extraColumns);
    }

    return defaultColumns;
  }, [extraColumns, t]);

  return (
    <Table
      title={t('cards.invoiceItems')}
      columns={columns}
      data={data}
      loading={!data}
      tableKey="invoiceItems"
      tabs={tabs}
      extraActions={extraActions}
      noPagination
    />
  );
};

export default InvoiceItems;
